import {
  RLProjectFieldMapping,
  IntegrationField,
} from 'module/api/integrations/salesforce/types';
import { Typography } from 'antd';
import { FC } from 'react';
import { DisplayDynamicValue } from '../../block-value';

interface RenderBlockDetailsProps {
  actions: RLProjectFieldMapping;
  fields: IntegrationField[];
}

const { Text } = Typography;

export const RenderBlockDetails: FC<RenderBlockDetailsProps> = ({
  actions,
  fields,
}) => {
  return (
    <div className="flex flex-col gap-4">
      {Object.keys(actions).map((action) => {
        const fieldData = fields.find(
          (datum) => datum.integrationFieldId === action,
        );
        const result = actions[action];

        if (result != null) {
          if (fieldData?.fieldName === 'teamMembers') {
            const list = Array.isArray(result)
              ? result
              : typeof result === 'string'
                ? (result as string)
                  .split(',')
                  .map((s) => ({ valueStr: s.trim(), label: s.trim() }))
                : [];
            if (list.length === 0) return null;
            return (
              <div key={action} className="max-w-full">
                <Text
                  ellipsis={{ tooltip: true }}
                  className="max-w-[var(--width-sm)]"
                >
                  {fieldData?.fieldLabel}
                </Text>
                :
                <div className="inline-flex flex-wrap gap-[var(--spacing-03)] mt-[var(--spacing-02)]">
                  {list.map((item, index) => {
                    const valueStr =
                      typeof item === 'object' && item != null && 'valueStr' in item
                        ? (item as { valueStr: string }).valueStr?.toString() ?? ''
                        : '';
                    const label =
                      typeof item === 'object' && item != null && 'label' in item
                        ? (item as { label: string }).label?.toString() ?? ''
                        : String(item);
                    return (
                      <DisplayDynamicValue
                        key={index}
                        valueStr={valueStr}
                        label={label || valueStr}
                        boldText
                      />
                    );
                  })}
                </div>
              </div>
            );
          }
          return (
            !!result?.label?.toString() && (
              <div
                key={action}
                className="flex items-center gap-2 max-w-full overflow-hidden"
              >
                <Text
                  ellipsis={{ tooltip: true }}
                  className="max-w-[var(--width-sm)] shrink-0"
                >
                  {fieldData?.fieldLabel}
                </Text>
                :
                <div className="min-w-0 flex-1">
                  <DisplayDynamicValue
                    valueStr={result?.valueStr?.toString() ?? ''}
                    label={result?.label?.toString() ?? ''}
                    boldText
                    forceSalesforceLogo={action === 'contactObject'}
                  />
                </div>
              </div>
            )
          );
        }

        return null;
      })}
    </div>
  );
};
